import React from 'react'
import { NotificationContextProps } from '../types'

export const NotificationContext = React.createContext<NotificationContextProps | undefined>(undefined)
